import { IsBoolean, IsString, IsEnum, IsNumber } from "class-validator";
import { Expose } from "class-transformer";
import { FORM_OF_PAYMENTS } from "@/static/formOfPayments";

export class OfficeFormOfPayment {
  @IsEnum(FORM_OF_PAYMENTS)
  @Expose()
  id!: FORM_OF_PAYMENTS;
  @IsString()
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  isCredit!: boolean;
  @IsBoolean()
  @Expose()
  isFromSaleDate!: boolean;
  @IsString()
  @Expose()
  currencyCode!: string;
  @IsString()
  @Expose()
  code!: string;
  @IsBoolean()
  @Expose()
  canIssueReceipt!: boolean;
  @IsBoolean()
  @Expose()
  canIssueReceiptIndividualContractor!: boolean;
  @IsBoolean()
  @Expose()
  isSelected!: boolean;
  @IsNumber()
  @Expose()
  recordStampId!: number;
}
